
import {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";
import {TChemical, TData} from "./usePDGeothermal";
import {getMedianOfTopPercent, getSumOfWells, getWellsData} from "../utils/utils";
import {
	GEOTHERMAL_PERCENT,
	GEOTHERMAL_PRODUCTION_CONST,
	GEOTHERMAL_WELLS_DEFAULT,
} from "../utils/consts";

interface WellsBar {
		name: string,
		cost: number,
		price: number,

}
export const useWellsGeothermal = () => {
		const [data, setData] = useState<{data: TData, chemical: TChemical}>({data: [], chemical: []});
		const [calculatedData, setCalculatedData] = useState<WellsBar[]>();
		const [isSum, setIsSum] = useState<boolean>(false);
		const [loading, setLoading] = useState(true);

		const fetchData = async (location?: string) => {
				try {
						setLoading(true);
						const response = await axios.get(`${API_BASE}/concentration/geothermal`, {
								headers: {
									'content-type': 'application/json',
								}
						});
						setData({data: response.data.data, chemical: response.data.chemical});
				} catch (error) {
						console.error(error);
				} finally {
						setLoading(false);
				}
		}

		useEffect(() => {
				fetchData();
		}, []);

		useEffect(() => {
				const calculatedData = !isSum  ?
					getMedianOfTopPercent(data!.data, data!.chemical, GEOTHERMAL_PERCENT, GEOTHERMAL_PRODUCTION_CONST, GEOTHERMAL_WELLS_DEFAULT):
					getSumOfWells(data!.data, data!.chemical, GEOTHERMAL_PERCENT, GEOTHERMAL_PRODUCTION_CONST, GEOTHERMAL_WELLS_DEFAULT);
				const finalData = getWellsData(calculatedData);
				setCalculatedData(finalData);
		}, [data])

		return { data, calculatedData, loading, setData, fetchData, setIsSum, isSum };
}